import { Status } from '@tmov/design-system';
import React from 'react';

import StatusLoteEnum from '../../../Enum/StatusLoteEnum';

export const getLoteStatusWidget = demandaStatus => {
  if (demandaStatus === StatusLoteEnum.CARREGANDO) {
    return (
      <Status
        label={StatusLoteEnum.getTipo(StatusLoteEnum.CARREGANDO).label}
        variant="success"
      />
    );
  }
  if (demandaStatus === StatusLoteEnum.SUSPENSO) {
    return (
      <Status
        label={StatusLoteEnum.getTipo(StatusLoteEnum.SUSPENSO).label}
        variant="error"
      />
    );
  }
  return (
    <Status
      label={StatusLoteEnum.getTipo(StatusLoteEnum.FINALIZADO).label}
      variant="inactive"
    />
  );
};
